import { z } from 'zod';
import { AuthAppKeySchema } from '../types/auth-app-key.js';

export namespace GetAuthApps {
  export const authAppItemSchema = z.object({
    id: z.number(),
    identifier: z.string(),
    name: z.string(),
    createdOn: z
      .union([z.string(), z.date()])
      .transform((val) => (typeof val === 'string' ? val : val.toISOString())),
    typeId: z.number(),
  });

  export const responseBodySchema = z.object({
    items: z.array(authAppItemSchema),
  });
  export type ResponseBody = z.infer<typeof responseBodySchema>;
}

export namespace GetAuthApp {
  export const paramsSchema = z.object({
    authAppId: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const responseBodySchema = z.object({
    id: z.number(),
    identifier: z.string(),
    name: z.string(),
    typeId: z.number(),
    createdOn: z
      .union([z.string(), z.date(), z.null()])
      .transform((val) => (val === null ? null : typeof val === 'string' ? val : val.toISOString())),
    providers: z.array(z.unknown()),
    whitelabeling: z.unknown(),
  });
  export type ResponseBody = z.infer<typeof responseBodySchema>;
}

export namespace CreateAuthApp {
  export const requestBodySchema = z.object({
    name: z.string(),
    typeId: z.number(),
  });
  export type RequestBody = z.infer<typeof requestBodySchema>;

  export const responseBodySchema = z.object({
    authApp: z.object({
      id: z.number(),
    }),
  });
  export type ResponseBody = z.infer<typeof responseBodySchema>;
}

export namespace GetAuthAppKeys {
  export const paramsSchema = z.object({
    authAppId: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const responseBodySchema = z.object({
    keys: z.array(AuthAppKeySchema),
  });
  export type ResponseBody = z.infer<typeof responseBodySchema>;
}

export namespace GetAuthAppKeyValue {
  export const paramsSchema = z.object({
    authAppId: z.coerce.number(),
    keyId: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const responseBodySchema = z.object({
    value: z.string(),
  });
  export type ResponseBody = z.infer<typeof responseBodySchema>;
}

export namespace CreateApplicationKey {
  export const paramsSchema = z.object({
    authAppId: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const requestBodySchema = z.object({
    name: z.string(),
    accessorApplicationId: z.number(),
  });
  export type RequestBody = z.infer<typeof requestBodySchema>;

  export const responseSchema = z.object({
    key: AuthAppKeySchema,
  });
  export type Response = z.infer<typeof responseSchema>;
}

export namespace DeleteApplicationKey {
  export const paramsSchema = z.object({
    authAppId: z.coerce.number(),
    keyId: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;
}
